/**
 * Simple template resolver for challenge card display strings.
 * Replaces {variable} placeholders with values from the variables map.
 * Unknown variables are replaced with empty string.
 */
export function resolveTemplate(
  template: string,
  variables: Record<string, string>,
): string {
  return template.replace(/\{(\w+)\}/g, (_, name) => variables[name] ?? '')
}
